exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".features-product-area---3WZju{margin-top:20px}", ""]);

// exports
exports.locals = {
	"features-product-area": "features-product-area---3WZju"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/views/app.home/style.scss
// module id = 366
// module chunks = 0